/** Um chip de filtro: o código da categoria de serviço (em texto) ou `todos`. */
export interface NoticiaCategoria {
  id: string;
  rotulo: string;
  cor: string;
}

export const NOTICIA_FILTRO_TODOS: NoticiaCategoria = {
  id: 'todos',
  rotulo: 'Todos',
  cor: '#0B2D63',
};

/** A categoria como a API pública a devolve: código, nome e a cor tema do adm. */
export interface CategoriaNoticiaResponse {
  codCategoriaServicoCtg: number;
  desNomeCtg: string;
  desCorTemaCtg: string;
}

/** Um item de `GET publico/noticia` e de `publico/noticia/destaque`. */
export interface NoticiaPublicaResponse {
  codNoticiaNtc: number;
  desSlugNtc: string;
  desTituloNtc: string;
  desSubtituloNtc: string;
  datPublicacaoNtc: string;
  /** Nula quando o código guardado não tem mais linha no cadastro de categorias. */
  categoria: CategoriaNoticiaResponse | null;
  bitPossuiImagemMobile: boolean;
}

/** A página de `GET publico/noticia`: o total vem do servidor, para a paginação. */
export interface NoticiaPaginaPublicaResponse {
  itens: NoticiaPublicaResponse[];
  numPagina: number;
  numTamanhoPagina: number;
  numTotal: number;
}

export interface ImagemNoticiaPublicaResponse {
  desFormatoNim: 'Desktop' | 'Mobile';
  desTextoAlternativoNim: string | null;
  desLegendaNim: string | null;
  desCreditoNim: string | null;
}

export interface SecaoNoticiaPublicaResponse {
  desTituloNsc: string;
  desDescricaoNsc: string | null;
  desTipoNsc: string;
  itens: { desNomeNsi: string; desLinkNsi: string }[];
}

export interface CardApoioNoticiaPublicaResponse {
  desTituloCardNtc: string | null;
  desCorCardNtc: string | null;
  desTextoApoioNtc: string | null;
  desTelefoneNtc: string | null;
  desWhatsappNtc: string | null;
  desEmailContatoNtc: string | null;
}

export interface BotaoServicoNoticiaPublicaResponse {
  desTextoChamadaNtc: string | null;
  desTipoDestinoNtc: string;
  codServicoSrv: number | null;
  desLinkAlternativoNtc: string | null;
  bitAbrirNovaAbaNtc: boolean;
}

/** `GET publico/noticia/{slug}`. Card, botão e citação vêm nulos quando estão desligados. */
export interface NoticiaDetalhePublicaResponse extends NoticiaPublicaResponse {
  desAutorNtc: string | null;
  desNomeDepartamento: string;
  imagens: ImagemNoticiaPublicaResponse[];
  desTextoPrincipalNtc: string | null;
  desCitacaoNtc: string | null;
  secoes: SecaoNoticiaPublicaResponse[];
  cardApoio: CardApoioNoticiaPublicaResponse | null;
  botaoServico: BotaoServicoNoticiaPublicaResponse | null;
  bitExibirCompartilhamentoNtc: boolean;
  redes: { desNomeNrd: string; desUrlNrd: string | null }[];
}

/** O card de notícia das listas, já com as URLs das artes. */
export interface Noticia {
  id: number;
  slug: string;
  titulo: string;
  descricao: string;
  /** Data ISO da publicação; o componente formata. */
  data: string;
  /** Nula: o card sai sem selo e a categoria fica fora dos chips. */
  categoria: NoticiaCategoria | null;
  imagem: string;
  /** A arte do celular, ou `null` quando a notícia não tem uma: o celular usa a desktop. */
  imagemMobile: string | null;
}

export const DESTINO_CARTA_SERVICO = 'Carta de serviço cadastrada';
export const DESTINO_LINK_EXTERNO = 'Link externo';
export const DESTINO_FORMULARIO_SIC = 'Formulário e-SIC';

export interface NoticiaDetalhe extends Noticia {
  autor: string | null;
  departamento: string;
  textoAlternativo: string;
  textoAlternativoMobile: string | null;
  legenda: string | null;
  credito: string | null;
  /** HTML do editor do adm, exibido por `[innerHTML]` com a sanitização do Angular. */
  textoPrincipal: string;
  citacao: string | null;
  secoes: SecaoNoticiaPublicaResponse[];
  card: CardApoioNoticiaPublicaResponse | null;
  botao: BotaoServicoNoticiaPublicaResponse | null;
  compartilhamento: boolean;
  redes: { nome: string; url: string | null }[];
}
